import { render } from "./MaterialPagination.vue?vue&type=template&id=21b8e27f"
import script from "./MaterialPagination.vue?vue&type=script&lang=js"
export * from "./MaterialPagination.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrew/Work/Projects/Pocketkey/qrdynamic/qrdynamic-admin/qrdynamic-admin-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__